import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { YourDriveIntegrationService } from '../../services/yourdrive-integration.service';

@Component({
  selector: 'app-dbms',
  templateUrl: './dbms.component.html',
  styleUrls: ['./dbms.component.scss']
})
export class DbmsComponent implements OnInit, OnDestroy, AfterViewInit {

  // Reference to the iframe element
  @ViewChild('ydFrame') iframeRef!: ElementRef<HTMLIFrameElement>;

  // Safe URL for iframe src — null until buildIframeSrc() resolves
  iframeSrc: SafeResourceUrl | null = null;

  // Loading state
  isLoading = true;
  loadError: string | null = null;

  // SSO cleanup function
  private ssoCleanup?: () => void;

  constructor(
    private yourDriveService: YourDriveIntegrationService
  ) {}

  async ngOnInit() {
    console.log('🚀 Initializing DBMS');

    try {
      // Check if user is authenticated
      const isAuth = await this.yourDriveService.isAuthenticated();
      if (!isAuth) {
        throw new Error('User is not authenticated');
      }

      // Method A — pass token in iframe URL on first load
      this.iframeSrc = await this.yourDriveService.buildIframeSrc();

      // Optional: listen for SSO feedback from YourDrive
      this.ssoCleanup = this.yourDriveService.listenForSsoResult(
        (userId) => {
          console.log('✅ DBMS SSO success, userId=', userId);
          this.isLoading = false;
        },
        (error) => {
          console.error('❌ DBMS SSO failed:', error);
          this.loadError = error;
          this.isLoading = false;
        }
      );

    } catch (error: any) {
      console.error('❌ Failed to initialize DBMS:', error);
      this.loadError = error.message || 'Failed to load DBMS';
      this.isLoading = false;
    }
  }

  ngAfterViewInit() {
    // Iframe load is now handled via (load) template binding; nothing needed here
  }

  onIframeLoad() {
    console.log('📄 DBMS iframe loaded');
    setTimeout(() => {
      if (!this.loadError) {
        this.isLoading = false;
      }
    }, 1000);
  }

  ngOnDestroy() {
    // Clean up event listeners
    if (this.ssoCleanup) {
      this.ssoCleanup();
    }
  }

  // Method to manually refresh SSO (useful if token expires)
  async refreshSSO() {
    if (!this.iframeRef?.nativeElement) {
      console.error('❌ Iframe reference not available');
      return;
    }

    try {
      console.log('🔄 Refreshing DBMS SSO token');
      await this.yourDriveService.postMessageSSO(this.iframeRef.nativeElement);
    } catch (error) {
      console.error('❌ Failed to refresh SSO:', error);
    }
  }

  // Retry loading on error
  async retry() {
    this.isLoading = true;
    this.loadError = null;
    await this.ngOnInit();
  }
}

